// extracted by mini-css-extract-plugin
module.exports = {"List":"StekList_List__3-ffh","Cards":"StekList_Cards__17mNH","Number":"StekList_Number__1cgnT"};